import {Suspense} from 'react';
import {useWindowScroll} from 'react-use';
import {
  Heading,
  IconAccount,
  IconBag,
  IconMenu,
  IconSearch,
  Input,
} from '~/components';

import {Link, useCart, useUrl} from '@shopify/hydrogen';

import {CartDrawer} from './CartDrawer.client';
import {useDrawer} from './Drawer.client';
import {Footer} from './Footer.client';
import Logo from './Logo.client';
import {MenuDrawer, getUrl} from './MenuDrawer.client';

import type {EnhancedMenu} from '~/lib/utils';
/**
 * A client component that specifies the content of the header on the website
 */
export function Header({title, menu, collectionsMenu, footerMenu}: any) {
  const {pathname} = useUrl();

  const localeMatch = /^\/([a-z]{2})(\/|$)/i.exec(pathname);
  const countryCode = localeMatch ? localeMatch[1] : undefined;

  const isHome = pathname === `/${countryCode ? countryCode + '/' : ''}`;

  const {
    isOpen: isCartOpen,
    openDrawer: openCart,
    closeDrawer: closeCart,
  } = useDrawer();

  const {
    isOpen: isMenuOpen,
    openDrawer: openMenu,
    closeDrawer: closeMenu,
  } = useDrawer();

  return (
    <>
      <CartDrawer isOpen={isCartOpen} onClose={closeCart} />
      <MenuDrawer
        isOpen={isMenuOpen}
        onClose={closeMenu}
        menu={menu!}
        collectionsMenu={collectionsMenu!}
        footerMenu={footerMenu}
      />
      <DesktopHeader
        countryCode={countryCode}
        isHome={isHome}
        title={title}
        menu={menu}
        footerMenu={footerMenu}
        openCart={openCart}
        openMenu={openMenu}
      />
 
    </>
  );
}

 

function DesktopHeader({
  countryCode,
  isHome,
  menu,
  footerMenu,
  openCart,
  title,
  openMenu,
}: {
  countryCode?: string | null;
  isHome: boolean;
  openCart: () => void;
  menu?: EnhancedMenu;
  title: string;
  footerMenu?: any;
  openMenu: () => void;
}) {
  return (
    <>
      <header className="w-full flex items-center justify-center fixed top-0 h-nav bg-white z-10">
        <div className="flex items-center absolute left-0 gap-6 ">
          <button onClick={openMenu} className="h-nav px-3 pr-0">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="40" height="40" fill="white" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 19.25L29 19.25L29 20.75L11 20.75L11 19.25Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 14L29 14L29 15.5L11 15.5L11 14Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 25L29 25L29 26.5L11 26.5L11 25Z"
                fill="black"
              />
            </svg>
          </button>
          <Link
            className="h-nav items-center justify-center hidden md:flex"
            to="/collections"
          >
            Collections
          </Link>
          <Link
            className="h-nav items-center justify-center hidden md:flex"
            to="/"
          >
            Shop
          </Link>
          <nav className="hidden 2xl:flex gap-6">
            {/* Top level menu items */}
            {(menu?.items || []).map((item) => (
              <Link key={item.id} to={getUrl(item.to)} target={item.target}>
                {item.title}
              </Link>
            ))}
          </nav>
          
          
        </div>
        <Link className="h-nav flex items-center" to="/">
          <Logo />
        </Link>
        <button
          className="absolute right-0 h-nav px-6 flex items-center -mt-1"
          onClick={openCart}
        >
          <span className="hidden md:inline">CART&nbsp;</span>
          <CartBadge dark={isHome} />
        </button>
      </header>
      <aside
        role="banner"
        className="hidden   w-3/12 flex-col justify-between h-screen sticky top-0 px-6 "
      >
        <div>
          <div className="flex flex-col pt-16">
            <nav className="flex flex-col">
              {/* Top level menu items */}
              {(menu?.items || []).map((item) => (
                <Link key={item.id} to={item.to} target={item.target}>
                  {item.title}
                </Link>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-1">
            {/* <form
          action={`/${countryCode ? countryCode + '/' : ''}search`}
          className="flex items-center gap-2"
        >
          <Input
            className={
              isHome
                ? 'focus:border-contrast/20 dark:focus:border-primary/20'
                : 'focus:border-primary/20'
            }
            type="search"
            variant="minisearch"
            placeholder="Search"
            name="q"
          />
          <button type="submit" className={styles.button}>
            <IconSearch />
          </button>
        </form> */}
            {/* <Link to={'/account'} className={styles.button}>
          <IconAccount />
        </Link> */}
          </div>
        </div>
        <div className="pb-6">
          <Suspense fallback={<Footer />}>
            <Footer menu={footerMenu} />
          </Suspense>
        </div>
      </aside>
    </>
  );
}

function CartBadge({dark}: {dark: boolean}) {
  const {totalQuantity} = useCart();

  return <span>({totalQuantity})</span>;
}
